import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CpfModalComponent } from './cpf-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { MaterialModule } from 'src/app/material-module';


@NgModule({
  declarations: [CpfModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    NgxMaskModule,
    
  ],
  exports:[CpfModalComponent]
})
export class CpfModalModule { }
